import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {EmptyItem} from 'devextreme-react/form';


export default class FormEmptyItem extends Component {
    render() {
        return <EmptyItem
            {...omit(['loading_state', 'setProps', 'children'], this.props)}
        />
    }
}

FormEmptyItem.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    /**
     * Specifies the number of columns spanned by the item
     */
    colSpan: PropTypes.number,
    /**
     * Specifies a CSS class to be applied to the form item
     */
    cssClass: PropTypes.string,
    /**
     * Specifies the item's type. Set it to "simple" to create a simple item
     */
    itemType: PropTypes.oneOf(['empty', 'group', 'simple', 'tabbed', 'button']),
    /**
     * Specifies a name that identifies the form item
     */
    name: PropTypes.string,
    /**
     * Specifies whether or not the current form item is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the sequence number of the item in a form, group or tab
     */
    visibleIndex: PropTypes.number,

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

FormEmptyItem.defaultProps = {
    // colSpan: undefined,
    // cssClass: undefined,
    itemType: 'simple',
    // name: undefined,
    visible: true,
    // visibleIndex: undefined
};
